import { each, isArray } from 'lodash';

const ClickOutsideElement = {
  bind(el, binding, vnode) {
    const element = el;
    element.event = (event) => {
      event.stopPropagation();
      const { handler, exclude } = binding.value;
      let clickedOnExcludedElement = false;
      each(exclude, (ref) => {
        if (!clickedOnExcludedElement) {
          const excludedElement = isArray(vnode.context.$refs[ref])
            ? vnode.context.$refs[ref][0] : vnode.context.$refs[ref];
          clickedOnExcludedElement = excludedElement.contains(event.target);
        }
      });
      if (!element.contains(event.target) && !clickedOnExcludedElement) {
        vnode.context[handler]();
      }
    };
    document.addEventListener('click', element.event);
  },
  unbind(element) {
    document.removeEventListener('click', element.event);
  },
};

export default ClickOutsideElement;
